import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://iymrjkthjjhxxfnjptnu.supabase.co'
const supabaseKey = 'sb_publishable_iOLwWBsUNvVgyETyQYtksg_4F8dCdKK'

export const supabase = createClient(
  supabaseUrl,
  supabaseKey
)